import * as React from 'react';
import {Redirect, Switch, Route} from 'react-router-dom';

import {CustomFieldsPage} from './custom-fields-page';

export function CustomFieldsRoot() {
    return (
        <Switch>
            <Redirect exact={true} from='/setup/custom-field' to='/setup/custom-field/company' />
            <Route
                path='/setup/custom-field/:tab'
                render={(routeProps) => {
                    return <CustomFieldsPage {...routeProps} />;
                }}
            />
        </Switch>
    );
}
